<template>
  <!-- 工业园平台操作后台 -->
  <div class="ahome">
    <a-header></a-header>
    <div class="content">
      <a-aside></a-aside>
      <div class="content_page">
        <div class="bread_menu">
          <Breadcrumb style="font-size: 0.875em">
            <BreadcrumbItem v-for="(item,index) in breadList" :key="index" :to="item.path">
              <span @click="selectBread(item)">
                <Icon :type="item.icon" v-if="item.icon"></Icon>
                {{ item.name }}
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div class="router">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scope>
.ahome {
  width: 100%;
  height: 100%;
  .content {
    height: calc(100% - 4em);
    display: flex;
    width: 100% !important;
    .content_page {
      width: calc(100% - 13em);
      height: 100%;
      background-color: #eee;
      position: relative;
      .bread_menu {
        width: 100%;
        background-color: #fff;
        text-align: left;
        padding: 0.25em;
        box-shadow: 0 2px 4px #ccc;
        position: absolute;
        top: 0;
        left: 0;
      }
      .router {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>

<script>
const header = () => import("../components/header");
const aside = () => import("../components/aside");

export default {
  data() {
    return {};
  },
  computed: {
    breadList() {
      //console.log(this.$store.state.admin.breadList);
      return this.$store.state.admin.breadList;
    }
  },
  components: {
    "a-header": header,
    "a-aside": aside
  },
  methods: {
    selectBread(params) {
      this.$store.commit("delBread", params.mname); // 菜单名 删除该菜单后的所有菜单
      this.$store.commit("editMenu", {
        path: params.mname,
        subId: params.subId || null
      });
    }
  }
};
</script>